import React, { useState } from 'react';
import styled from 'styled-components';
import TextareaAutosize from 'react-textarea-autosize';
import { BigButton } from '@/components/big-button';

type Props = {
  title: string;
  onSave: (v: string) => void;
  placeholder?: string;
  description?: string;
};

export function TextInputPopover({
  title,
  onSave,
  placeholder,
  description,
}: Props) {
  const [value, setValue] = useState<string>(``);

  return (
    <Wrapper>
      <Title>{title}</Title>
      <TextArea
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      {description && <Description>{description}</Description>}
      <ActionButton
        disabled={!value.replace(/ /g, ``)}
        noTransform
        onClick={() => onSave(value)}
      >
        Save
      </ActionButton>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  font-family: 'Inter', serif;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;

  width: 25rem;
  gap: 2rem;
  padding: 2rem;
  border-radius: 10px;
  border: 1px solid rgba(151, 151, 151, 0.1);
  background-color: #ffffff;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.18),
    0 14px 16px 0 rgba(177, 217, 203, 0.18), 0 5px 16px 0 rgba(0, 0, 0, 0.05),
    0 -10px 10px -5px rgba(0, 0, 0, 0.1);
`;

const TextArea = styled(TextareaAutosize)`
  && {
    font-family: Inter, serif;
    appearance: none;
    -webkit-appearance: none;
    pointer-events: auto;
    outline: none;
    border: 1px solid #d2d2d2;
    border-radius: 10px;
    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.1);
    text-align: left;
    color: black;
    width: 100%;
    font-size: 1.15rem;

    resize: none;
    min-height: 7rem;

    padding: 1rem;
    margin: 0;
  }
`;

const Title = styled.p`
  && {
    font-size: 1.3rem;
    font-weight: 600;
    color: black;
    margin: 0;
  }
`;

const Description = styled.p`
  && {
    font-size: 1.3rem;
    font-weight: 600;
  }
`;

const ActionButton = styled(BigButton)`
  && {
    font-size: 1.3rem;
    width: 100%;
  }
`;
